import Footer from "../components/Footer";

const values = [
  {
    mark: "01",
    title: "Indian Skin First",
    text: "Every formula is planned around humidity, pollution, melanin-rich skin, and everyday Indian routines.",
  },
  {
    mark: "02",
    title: "Ritual Meets Research",
    text: "Kesar, haldi, neem, and chandan are paired with modern actives for focused, measurable care.",
  },
  {
    mark: "03",
    title: "Clean Luxury",
    text: "Elevated textures, mindful packaging, and gentle performance without harsh or unnecessary fillers.",
  },
];

const metrics = [
  { value: "50K+", label: "Rituals shipped" },
  { value: "12+", label: "Botanical actives" },
  { value: "4.8/5", label: "Customer rating" },
];

const timeline = [
  {
    year: "2018",
    title: "Ingredient research",
    text: "We began with traditional Indian botanicals and lab-backed stability testing.",
  },
  {
    year: "2020",
    title: "First ritual launch",
    text: "Our first glow and barrier routines reached early customers through direct channels.",
  },
  {
    year: "2023",
    title: "Clean beauty expansion",
    text: "New ranges, improved textures, and more thoughtful packaging entered the collection.",
  },
];

const About = () => {
  return (
    <>
      <main className="page-shell premium-about-page">
        <section className="premium-about-hero">
          <div className="section-container premium-about-hero-grid">
            <div className="premium-about-copy">
              <p className="eyebrow">Our story</p>
              <h1>Ayurvedic rituals, refined for modern Indian skin.</h1>
              <p>
                VEDA GLOW was created for people who want skincare to feel both
                rooted and effective. We blend traditional Indian ingredients
                with clean actives, elegant textures, and routines that fit real
                life.
              </p>

              <div className="premium-about-actions">
                <a className="primary-btn" href="#/shop">
                  Shop the ritual
                </a>
                <a className="secondary-btn" href="#/contact">
                  Talk to us
                </a>
              </div>

              <div className="premium-about-metrics" aria-label="Brand metrics">
                {metrics.map((metric) => (
                  <div key={metric.label}>
                    <strong>{metric.value}</strong>
                    <span>{metric.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="premium-about-media">
              <img
                src="https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=1000&q=80"
                alt="Premium skincare products arranged with soft light"
              />
              <div className="premium-about-floating">
                <span>Formulated in small batches</span>
                <strong>Clean actives + Indian botanicals</strong>
              </div>
            </div>
          </div>
        </section>

        <section className="section-container premium-about-story">
          <div className="premium-about-story-card">
            <div>
              <p className="eyebrow">Philosophy</p>
              <h2>Skincare should feel intentional, not complicated.</h2>
            </div>
            <p>
              Our routines are designed around fewer, better steps: cleanse,
              treat, moisturize, protect, and restore. Each product has a clear
              purpose, a sensory finish, and a place in the ritual.
            </p>
          </div>
        </section>

        <section className="section-container premium-about-values">
          <div className="section-heading center">
            <p>Values</p>
            <h2>What makes us different</h2>
            <span>
              A premium skincare experience with ingredient clarity and daily
              usability at the center.
            </span>
          </div>

          <div className="premium-value-grid">
            {values.map((value) => (
              <article className="premium-value-card" key={value.title}>
                <span>{value.mark}</span>
                <h3>{value.title}</h3>
                <p>{value.text}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="premium-about-lab">
          <div className="section-container premium-about-lab-grid">
            <img
              src="https://images.unsplash.com/photo-1612817288484-6f916006741a?auto=format&fit=crop&w=900&q=80"
              alt="Luxury skincare texture and product display"
            />
            <div>
              <p className="eyebrow">Inside the formula</p>
              <h2>Textures made for repeat rituals.</h2>
              <p>
                We test for comfort, layering, fragrance balance, and finish so
                the routine feels beautiful in the morning and restorative at
                night.
              </p>
              <div className="premium-about-pills">
                <span>Dermat tested</span>
                <span>No harsh fillers</span>
                <span>Barrier supportive</span>
                <span>Climate conscious</span>
              </div>
            </div>
          </div>
        </section>

        <section className="section-container premium-about-timeline">
          <div className="section-heading split">
            <div>
              <p>Journey</p>
              <h2>From kitchen rituals to clean formulations</h2>
            </div>
            <span>
              We keep the soul of traditional care while refining every formula
              for safety, stability, and everyday performance.
            </span>
          </div>

          <ol>
            {timeline.map((item) => (
              <li key={item.year}>
                <span>{item.year}</span>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default About;
